/*
 * Request Load Spinner
 */

;$(function($) {

  // Private constants
  const pluginNameSpace = "requestLoadSpinner";
  const loaderSelector = ".request-loader";
  const loaderDelay = 300; // miliseconds

  // Private variables
  var timeouts = [];
  var $loader=$(loaderSelector);
  $loader.hide();

  document.onvisibilitychange = () => {
    if (document.visibilityState === "hidden") {
      $loader.hide()
      for (var i=0; i<timeouts.length; i++) {
        clearTimeout(timeouts[i]);
      }
    }
  };

  $.fn.formLoader = function (/* options */) {
    if ($loader.length && this.length)
      this.on("submit." + pluginNameSpace, onRequest);
    return this;
  };

  $.fn.requestLoader = function (/* options */) {
    if ($loader.length && this.length)
      this.on("click." + pluginNameSpace, onRequest);
    return this;
  };

  // Private functions
  function onRequest() {
    timeouts.push(setTimeout(function () { $loader.show() }, loaderDelay ));
    return true;
  }

}(jQuery));

$(function () {
  $("form:not([data-spinner='disable'])").formLoader();
//  $("a:not([href^='#'])").requestLoader();
});